declare const process: {
  env?: {
    WEB_API_URL?: string;
  };
};

const DEFAULT_API_URL = 'http://localhost:3010';

export function getApiUrl() {
  const configured = process.env?.WEB_API_URL?.trim();
  if (configured) {
    return configured.replace(/\/$/, '');
  }
  return DEFAULT_API_URL;
}
